import { computed, Injectable, signal } from '@angular/core';

import { EMPTY_REPORT, ReportData } from './report.model';

/**
 * État partagé du signalement en cours de saisie (équivalent du service `Report`
 * d'OSER). Persisté uniquement en mémoire pour la durée du parcours.
 */
@Injectable({ providedIn: 'root' })
export class ReportStore {
  private readonly _data = signal<ReportData>({ ...EMPTY_REPORT });

  readonly data = this._data.asReadonly();

  // Le type est choisi (report-type validé).
  readonly hasType = computed(() => Boolean(this._data().incident_type && this._data().location_type));

  // Les données de détail minimales sont présentes (report-detail validé).
  readonly hasReportData = computed(() => this.hasType() && Boolean(this._data().description));

  patch(partial: Partial<ReportData>): void {
    this._data.update((current) => ({ ...current, ...partial }));
  }

  reset(): void {
    this._data.set({ ...EMPTY_REPORT, report_date: new Date() });
  }
}
